import { render, staticRenderFns } from "./comp_dpc-Newsletter.vue?vue&type=template&id=4e626a2c&scoped=true&"
import script from "./comp_dpc-Newsletter.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-Newsletter.vue?vue&type=style&index=0&id=4e626a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e626a2c",
  null
  
)

export default component.exports